export default __webpack_public_path__ + "static/media/bank.f00dc04b.svg";